import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';
import * as productSearchActions from './productSearchActions';
import {GlobalHeader, BackButton} from '../common/GlobalHeader';
import moment from 'moment';
import i18n from 'i18next';
import translations from "../translations";
import ProductSearchCalendar from './ProductSearchCalendar';
import {
  hasDateWithFlight,
  isReturnDateDisabled
} from './calendarUtils';
import './calendar.scss'

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class AddFlightContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {flash: null};
    this.setTravelDate = this.setTravelDate.bind(this);
    this.goToItinerary = this.goToItinerary.bind(this);

    moment.locale(Flyblade.locale);
  }

  componentWillMount() {
    this.props.actions.selectTravelDate(null);
    this.props.actions.calendarParameters();
  }

  setTravelDate(date) {
    let {
      minimum_departure_date,
      closed_weekdays,
      dates_with_flights
    } = this.props;

    if (
      !hasDateWithFlight(date, dates_with_flights) ||
      isReturnDateDisabled(date, minimum_departure_date, closed_weekdays)
    ) { return; }

    this.props.actions.selectTravelDateAndContinue(date);
  }

  goToItinerary(date) {
    window.location.href = '/booking/review-summary';
  }

  render() {
    let {
      minimum_departure_date,
      dates_with_flights,
      closed_weekdays
    } = this.props;
    const renderDay = buildDays(minimum_departure_date, dates_with_flights, closed_weekdays);

    return (
      <div className="page-layout">
        <GlobalHeader
          leftComponent={<BackButton onClick={this.goToItinerary} />}
          title={i18n.t('flightSearch.selectReturnDate')} />

        <div className="page-layout-body" style={{overflow: 'hidden'}}>
          <ProductSearchCalendar
            numberOfMonths={12}
            onDayClick={this.setTravelDate}
            renderDay={renderDay}
          />
        </div>
      </div>
    )
  }
}

const buildDays = (minDeparture, datesWithFlights, closedWeekdays) => {
  const flightDates = new Set(datesWithFlights);
  return day => {
    var hasFlight = hasDateWithFlight(day, flightDates);

    return (
      <Day
        day={day}
        isDisabled={isReturnDateDisabled(day, minDeparture, closedWeekdays)}
        hasFlight={hasFlight}  />
    );
  }
}

const Day = ({day, isSelected, isDisabled, hasFlight}) => {
  return (
    <div className={classnames(
      {
        'is-disabled': !hasFlight || isDisabled,
        'has-flight': hasFlight && !isDisabled
      }
    )}>
      <span>{day.format('D')}</span>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    minimum_departure_date: state.productSearch.minimum_departure_date,
    dates_with_flights: state.productSearch.dates_with_flights,
    closed_weekdays: state.productSearch.closed_weekdays
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(productSearchActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFlightContainer);
